import React from 'react'
import './Hero.css'
import hand_icon from '../Assets/hand_icon.png'
import arrow_icon from '../Assets/arrow.png'
import hero_image from '../Assets/hero_image.png'
import bg_3 from "../Assets/bg_2.jpg"

const Hero = () => {
  return (
    <div className='hero'>
      
        <div className="hero-left">
            <h2>NEW ARRIVAL ITEMS</h2>
            <div>
                <div className="hero-hand-icon">
                    <p>New</p>
                    <img src={hand_icon} alt="" />
                </div>
                <p>collection</p>
                <p><span>for everyone</span></p>
            </div>
            <div className="hero-latest-btn">
              <div>Latest Collection</div>
              <img src={arrow_icon} alt="" />
            </div>
        </div>
        <div className="hero-right">
        {/* <img src={bg_3} alt="" /> */}
        </div>
    </div>
  )
}

export default Hero
